import React from "react";
import {
    KICK_ACTOR_LABEL,
    KICK_RULES_LABEL,
    PLATFORM_API_ACTOR_LABEL,
} from "@common/constants/actor";
import { ActivitySeries } from "@common/schemas/domains/activity/activity-timeline.schema";
import { ActorKind } from "@common/types/auditLog";
import { KickAvatar } from "@components/avatar/KickAvatar";
import actorIconStyles from "@components/history/components/ActorIcon.module.scss";
import { CliIcon, IntegrationsIcon, MembersIcon, RulesIcon } from "@icons";

/** The Updated by item value of a series row. */
export const toSeriesFilterValue = (series: ActivitySeries): string =>
    `series-${series}`;

export interface ListedSeriesParams {
    pickableSeries: readonly ActivitySeries[];
    pickedSeries: readonly ActivitySeries[] | undefined;
}

/** The series rows an Updated by lists: the pickable ones, plus All people only while picked, as a People slice click picks it. */
export const toListedSeries = ({
    pickableSeries,
    pickedSeries,
}: ListedSeriesParams): ActivitySeries[] =>
    pickedSeries?.includes(ActivitySeries.PEOPLE)
        ? [...pickableSeries, ActivitySeries.PEOPLE]
        : [...pickableSeries];

/** The actor kinds Updated by lists as Kick, Rule and Platform API rows. */
export type FilterAgentKind =
    | ActorKind.RULE
    | ActorKind.KICK
    | ActorKind.ORGANIZATION;

export const FILTER_AGENT_ICONS: Record<FilterAgentKind, React.ReactNode> = {
    [ActorKind.RULE]: <RulesIcon />,
    [ActorKind.KICK]: <KickAvatar size="xs" aria-hidden />,
    [ActorKind.ORGANIZATION]: (
        <CliIcon className={actorIconStyles.glyphIcon} aria-hidden />
    ),
};

export function getAgentFilterLabel(kind: FilterAgentKind): string {
    if (kind === ActorKind.RULE) {
        return KICK_RULES_LABEL;
    }
    if (kind === ActorKind.ORGANIZATION) {
        return PLATFORM_API_ACTOR_LABEL;
    }
    return KICK_ACTOR_LABEL;
}

export const SERIES_FILTER_LABELS: Record<ActivitySeries, string> = {
    [ActivitySeries.PEOPLE]: "All people",
    [ActivitySeries.KICK]: getAgentFilterLabel(ActorKind.KICK),
    [ActivitySeries.INTEGRATIONS]: "All integrations",
    [ActivitySeries.RULES]: getAgentFilterLabel(ActorKind.RULE),
};

export const SERIES_FILTER_ICONS: Record<ActivitySeries, React.ReactNode> = {
    [ActivitySeries.PEOPLE]: <MembersIcon />,
    [ActivitySeries.KICK]: FILTER_AGENT_ICONS[ActorKind.KICK],
    [ActivitySeries.INTEGRATIONS]: <IntegrationsIcon />,
    [ActivitySeries.RULES]: FILTER_AGENT_ICONS[ActorKind.RULE],
};
